{
  "version": 1,
  "asset_id": "809d6e28-3763-4aeb-a239-aa113b039865",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/809d6e28-3763-4aeb-a239-aa113b039865/clip-img_0015.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/809d6e28-3763-4aeb-a239-aa113b039865/clip-img_0015.mp4",
  "original_filename": "clip-img_0015.mp4",
  "size": 470703,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:24Z"
}
